import { render, staticRenderFns } from "./PostLoginLayout.vue?vue&type=template&id=0ffaa564"
import script from "./PostLoginLayout.vue?vue&type=script&lang=js"
export * from "./PostLoginLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports